(function () {
  const reviewsPath = '/pages/reviews';

  function isJudgeMeReviewLink(anchor) {
    if (!anchor.closest('[class*="jdgm"], [id*="jdgm"], .shopify-app-block')) return false;
    const href = anchor.getAttribute('href') || '';
    const label = (anchor.textContent || '').trim().toLowerCase();
    return /judge\.me|judgeme/.test(href) && /review|from \d+/.test(label);
  }

  document.addEventListener('click', (event) => {
    const anchor = event.target.closest('a');
    if (!anchor || !isJudgeMeReviewLink(anchor)) return;
    event.preventDefault();
    window.location.assign(reviewsPath);
  });
})();
